import { render } from "./ExtractionView.vue?vue&type=template&id=4a57d455&scoped=true"
import script from "./ExtractionView.vue?vue&type=script&lang=js"
export * from "./ExtractionView.vue?vue&type=script&lang=js"

import "./ExtractionView.vue?vue&type=style&index=0&id=4a57d455&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a57d455"]])

export default __exports__